import { BasicRequest } from "./basicRequest";

export class DeleteAllocationDefinitionRequest extends BasicRequest{
    public allocationDefinitionId! : number;
    public physicalDelete : boolean=false;
}